(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
      var roots = document.querySelectorAll('[data-variant-picker]');
      roots.forEach(function (root) {
        var productId = root.getAttribute('data-product-id');
        var jsonEl = root.querySelector('[data-variant-json]');
        var idInput = document.getElementById('variant-id-' + productId);
        var addBtn = document.querySelector('[data-add-to-cart="' + productId + '"]');
        if (!jsonEl || !idInput) return;

        var variants;
        try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
        if (!Array.isArray(variants)) return;

        var selects = root.querySelectorAll('select[data-option-index]');
        var swatches = root.querySelectorAll('[data-swatch]');
        var addLabel = addBtn ? addBtn.textContent.trim() : '';
        var unavailableLabel = jsonEl.getAttribute('data-unavailable-label') || 'Unavailable';

        function currentSelections() {
          var sel = [];
          selects.forEach(function (s) {
            sel[parseInt(s.getAttribute('data-option-index'), 10)] = s.value;
          });
          return sel;
        }

        function findVariant(sel) {
          return variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === sel[i]; });
          });
        }

        function syncOption(optIndex, value) {
          root.querySelectorAll('[data-swatch][data-option-index="' + optIndex + '"]').forEach(function (b) {
            var on = b.getAttribute('data-value') === value;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          var label = root.querySelector('[data-selected-label][data-option-index="' + optIndex + '"]');
          if (label) label.textContent = value;
        }

        function update() {
          var sel = currentSelections();
          sel.forEach(function (v, i) { syncOption(i, v); });
          var variant = findVariant(sel);
          if (variant) idInput.value = variant.id;
          if (addBtn) {
            var available = variant && variant.available;
            addBtn.disabled = !available;
            addBtn.textContent = available ? addLabel : unavailableLabel;
          }
        }

        selects.forEach(function (s) { s.addEventListener('change', update); });
        swatches.forEach(function (b) {
          b.addEventListener('click', function () {
            var i = b.getAttribute('data-option-index');
            var val = b.getAttribute('data-value');
            var s = root.querySelector('select[data-option-index="' + i + '"]');
            if (s) s.value = val;
            update();
          });
        });

        update();
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
